import { Component, OnInit, NgZone, ViewChild, Input } from '@angular/core';
import { AuthenticationService } from "../services/authentication.service";
import Swal from 'sweetalert2';
import { environment } from "../../environments/environment";
import { GooglePlaceDirective } from "node_modules/ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive";
declare const google: any;
declare module "googlemaps";
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
@Component({
  selector: 'app-add-advertisement',
  templateUrl: './add-advertisement.component.html',
  styleUrls: ['./add-advertisement.component.css']
})
export class AddAdvertisementComponent implements OnInit {
  @ViewChild("addresstextNew") addresstextNew: any;
  @Input() googleAdressType: any;
  public form: FormGroup;
  public imagePath: any;
  public addresses: any;
  public address: any;
  locationModel: NgbModalRef;
  public addressLocation: any;
  spinnerType = SPINNER.circle;
  public submitted = false;
  public addModel: any;
  public locationId: any;
  public locations: any;
  public images: any;
  public skip: any;
  public limit: any;
  boundsLimit = true;
  private geoCoder;
  isImages = false;
  formattedaddress = " ";
  // public AddressChange(address: any) { 
  //   console.log('address---------',address);
  //        this.formattedaddress=address.formatted_address;
  //        if(this.formattedaddress){
  //         setTimeout(() => this.getGoogleAddress(this.formattedaddress))
  //        }
  // } 
  defaultBounds;
  @ViewChild("placesRef") placesRef: GooglePlaceDirective;
  constructor(private ngxService: NgxUiLoaderService, public router: Router, private modalService: NgbModal, private zone: NgZone, public fb: FormBuilder, public authenticationService: AuthenticationService) { }
  ngOnInit(): void {
    this.form = this.fb.group({
      title: ['', [Validators.required]],
      description: ['', []],
      startDate: ['', []],
      endDate: ['', []],
      location: ['']
    })
    this.getLocation();
    this.skip = 0;
    this.limit = 5;
    this.images = [];
    this.getGallery();
    let address1 = JSON.parse(localStorage.getItem('address1'));
    // if(address1){
    //   this.form.patchValue({
    //     title: address1.title || '',
    //     description: address1.description || '',
    //     location: address1.location,
    //     startDate: address1.startDate
    //   });
    //   this.imagePath = address1?.imagePath || '';
    // }

  }
  get f() { return this.form.controls; }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log(file.name)
      const formData = new FormData();
      console.log(formData, 'testing')
      formData.append('image', file, file.name);
      formData.append('imageType', 'image');
      this.ngxService.start();
      // this.loading = true;
      this.authenticationService
        .upload(formData)
        .subscribe(
          data => {
            this.imagePath = environment.basePath + data['data'].url;
            this.ngxService.stop();
          },

          error => {
            Swal.fire(
              "Oops...",
              error.error.message,
              "error"
            );
            this.ngxService.stop();
          }
        );
    } else {
      Swal.fire(
        "error",
        "Oops...",
        "error"
      );
    }
  }

  addressChange() {
    console.log('this.addresstext----', this.addresstextNew)
    if (!this.addresstextNew) {
      return
    }
    setTimeout(() => this.getGoogleAddress(this.addresstextNew))
  }

  getGoogleAddress(address: any) {
    let addressData: any = [];
    console.log('adddress text^^^^^^^^^^', address, 'this.formattedaddress----', this.formattedaddress)
    const autocomplete = new google.maps.places.Autocomplete(
      address?.nativeElement,
      {
        // componentRestrictions: { country: 'US' }, //canada
        types: [this.googleAdressType], // 'establishment' / 'address' / 'geocode'
      }
    );
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      console.log('enter');

      const place: any = autocomplete?.getPlace();
      console.log('--place++++++++203', place)
      if (place) {

        console.log("place", place)
        place.address_components.find((data: any) => {
          if (data.types.includes('postal_code')) {
            addressData.zipCode = data.long_name
          }
          if (data.types.includes("country")) {
            addressData.country = data.long_name
          }
          if (data.types.includes("administrative_area_level_1")) {
            addressData.state = data.long_name
          }
          if (data.types.includes("locality")) {
            addressData.city = data.long_name
          }
        }
        );

        console.log("addressDataaddressDataaddressDataaddressData", addressData)

        addressData.formattedAddress = place.formatted_address;
        addressData.name = place.name;
        let arr = place?.formatted_address?.split(',');
        // addressData.city = arr[1];
        // let arr1 = arr[2]?.split('');
        // addressData.state = arr1[1] ? arr1[1] : '';
        // addressData.zipCode = arr1[2] ? arr1[2] : '';
        // addressData.country = arr[3] ? arr[3] : '';

        // this.invokeEvent(place);
        let lat = place?.geometry?.location.lat();
        let lng = place?.geometry?.location.lng();
        addressData.coordinate = [lat, lng];
      }
    });

    console.log("addressData", addressData)

    return addressData;
  }

  addAdddress() {
    // console.log('this.form----',this.form.value)
    // console.log('this.imagePath----',this.imagePath);
    let addressObj = this.form.value;
    addressObj['imagePath'] = this.imagePath;
    localStorage.setItem('address1', JSON.stringify(addressObj));
    this.router.navigateByUrl('/select-criteria');
  }

  openInfo(content) {
    this.locationModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false
    });
  }

  public onSubmit(result): void {
    console.log(result, '###-----###')
    this.submitted = true;
    if (!this.imagePath) {
      Swal.fire(
        "X",
        "Image is required",
        "error"
      );
      return
    }
    if (this.form.invalid) {
      return;
    }
    let adObj = {}
    adObj['title'] = result.title;
    adObj['imagePath'] = this.imagePath;
    adObj['description'] = result.description;
    adObj['address'] = this.locationId;
    // adObj['address'] = {streetAddress: result.streetAddress, landMark: result.landMark, googleAddress:result.googleAddress, city:result.city, state:result.state, country: result.country, postalCode:result.postalCode, location:this.addressLocation, address_contact_no: result.address_contact_no,address_alternateContact_no:result.address_alternateContact_no}
    adObj['startDate'] = result.startDate;
    adObj['endDate'] = result.endDate;
    this.ngxService.start();
    this.authenticationService.addAdvertisement(adObj).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.submitted = false;
        console.log(response, '')
        Swal.fire("", "Advertisement is created sucessfully.", 'success')
        this.router.navigate(['/advertisements']);
      },
      error => {
        this.ngxService.stop();
        this.submitted = false;
        if (error) {
          Swal.fire(
            "Error",
            error.error.message,
            "error"
          );
        }
      }
    );
  }
  selectImageFrom(image: any) {
    console.log('image---', image);

    this.imagePath = image;
    this.locationModel.close();
  }
  checkImage(usr: any) {
    if (usr) {
      let pathArray = usr.split('/');
      let protocol = pathArray[0];
      let host = pathArray[2];
      let url = protocol + '//' + host + '/';
      console.log(pathArray, protocol, host, url, 'testing123')
      if (url == environment.basePath) {
        return usr
      } else {
        return environment.basePath + usr
      }
    }
  }
  redirectTo(type) {
    if (type == 1) {
      this.locationModel.close();
      // this.router.navigate(['/plans'], { queryParams: {isSub: false}});
      this.router.navigate(['/mysubscration'], { queryParams: { isSub: false } });
    } else {
      this.router.navigate(['/dashboard'])
    }

  }
  selectLocation(location) {
    this.locationId = location._id;
    this.form.controls['location'].setValue(location.googleAddress);
    this.locationModel.close();
  }
  getLocation(): void {
    this.authenticationService.getLocations().subscribe(
      (response: any) => {
        console.log('locations==response', response);

        this.locations = response['data'].subscriptions;
        console.log(this.locations, 'testingdsad')
      },
      error => {
        if (error.error.message == "Unauthorized") {
          this.authenticationService.logout();
        }
      }
    );
  }

  getGallery() {
    this.authenticationService.getGalleryImages(this.skip, this.limit).subscribe((res: any) => {
      console.log(res, 'testing');

      if (res.items?.length > 0) {
        this.isImages = true;
        this.images = [...this.images, ...res.items];
        this.skip += this.limit;
        console.log(this.images, 'res')
      } else {
        if (this.skip === 0) {
          // No images at all on first load
          this.isImages = false;
        }
        // On Load More, keep existing images visible even if no new ones came back
      }
      console.log(this.images, '-----data')
    },
      error => {
        if (error.error.message == "Unauthorized") {
          this.authenticationService.logout();
        }
      }
    )
  }

}
